import { db } from '../firebase';
import {
  collection,
  endAt,
  getDocs,
  limit,
  orderBy,
  query,
  startAt,
  where,
} from 'firebase/firestore';

const SEARCH_CACHE_TTL_MS = 60 * 1000;
const searchCache = new Map();

function readCache(key) {
  const entry = searchCache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.ts > SEARCH_CACHE_TTL_MS) {
    searchCache.delete(key);
    return null;
  }
  return entry.items || null;
}

function writeCache(key, items) {
  searchCache.set(key, { ts: Date.now(), items });
}

async function tryPrefix(colName, field, qText, take) {
  try {
    const q1 = query(
      collection(db, colName),
      orderBy(field),
      startAt(qText),
      endAt(qText + '\uf8ff'),
      limit(take)
    );
    const s1 = await getDocs(q1);
    return s1.docs.map((d) => ({ id: d.id, __col: colName, ...d.data() }));
  } catch {
    return [];
  }
}

export async function fetchSearchCandidates(qTextRaw, opts = {}) {
  const take = Number.isFinite(Number(opts.take)) ? Math.max(1, Number(opts.take)) : 10;
  const minQueryLength = Number.isFinite(Number(opts.minQueryLength))
    ? Math.max(1, Number(opts.minQueryLength))
    : 2;
  const qText = String(qTextRaw || '').trim().toLowerCase();

  if (qText.length < minQueryLength) return [];

  const cacheKey = `${qText}::${take}`;
  const cached = readCache(cacheKey);
  if (cached) return cached;

  const qTpl = query(
    collection(db, 'bookTemplates'),
    where('searchTokens', 'array-contains', qText),
    limit(take)
  );
  const templateRows = (await getDocs(qTpl)).docs.map((d) => ({ id: d.id, __col: 'bookTemplates', ...d.data() }));
  let arr = templateRows;

  if (arr.length < take) {
    const qBooks = query(
      collection(db, 'books'),
      where('searchTokens', 'array-contains', qText),
      limit(take - arr.length)
    );
    const bookRows = (await getDocs(qBooks)).docs.map((d) => ({ id: d.id, __col: 'books', ...d.data() }));
    arr = [...arr, ...bookRows];
  }

  if (!arr.length) {
    let byTitle = await tryPrefix('bookTemplates', 'titleLower', qText, take);
    if (!byTitle.length) byTitle = await tryPrefix('bookTemplates', 'title', qText, take);
    let byAuthor = await tryPrefix('bookTemplates', 'authorLower', qText, take);
    if (!byAuthor.length) byAuthor = await tryPrefix('bookTemplates', 'author', qText, take);

    if (!byTitle.length && !byAuthor.length) {
      byTitle = await tryPrefix('books', 'titleLower', qText, take);
      if (!byTitle.length) byTitle = await tryPrefix('books', 'title', qText, take);
      byAuthor = await tryPrefix('books', 'authorLower', qText, take);
      if (!byAuthor.length) byAuthor = await tryPrefix('books', 'author', qText, take);
    }

    const map = new Map();
    for (const row of [...byTitle, ...byAuthor]) map.set(`${row.__col || ''}|${row.id}`, row);
    arr = Array.from(map.values());
  }

  writeCache(cacheKey, arr);
  return arr;
}

